// src/internal/components/help-center-panel/functions/create-resource.ts
var createResource = (promise) => {
  let status = "loading";
  let result;
  let suspender = promise.then(
    (data) => {
      status = "success";
      result = data;
    },
    (error) => {
      status = "error";
      result = error;
    }
  );
  return {
    read() {
      if (status === "loading") {
        throw suspender;
      } else if (status === "error") {
        throw new Error(result == null ? void 0 : result.message);
      } else if (status === "success") {
        return result;
      } else {
        return result;
      }
    }
  };
};

export {
  createResource
};
